// extracted by mini-css-extract-plugin
module.exports = {"container":"submit-work-module--container--2KcQW","submitWorkFooter":"submit-work-module--submitWorkFooter--1qBem","form":"submit-work-module--form--36muR"};